module.exports = __webpack_public_path__ + "4e83f173196cfb98c7c7b6e122141bdf.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/component/login/background.mp4
// module id = 274
// module chunks = 0